let _oosConfirmCallback = null;
let _oosPreviousFocus = null;
let _oosPreviousOverflow = "";

function openOosModal(onConfirm) {
  const modal = document.getElementById("v-oos-modal");

  if (!modal) {
    if (onConfirm) onConfirm();
    return;
  }

  _oosConfirmCallback = onConfirm;
  _oosPreviousFocus = document.activeElement;
  _oosPreviousOverflow = document.body.style.overflow;

  modal.hidden = false;
  document.body.style.overflow = "hidden";

  modal.querySelector("[data-oos-confirm]")?.focus();
}

function closeOosModal() {
  const modal = document.getElementById("v-oos-modal");
  if (!modal || modal.hidden) return;

  modal.hidden = true;
  document.body.style.overflow = _oosPreviousOverflow;

  _oosConfirmCallback = null;

  if (_oosPreviousFocus?.isConnected) {
    _oosPreviousFocus.focus();
  }

  _oosPreviousFocus = null;
}

function buyItNow() {
  const atcBtn = document.getElementById("v-atc-btn");
  if (atcBtn?.dataset.preorder === "true") {
    openOosModal(_doBuyItNow);
    return;
  }
  _doBuyItNow();
}

function _doBuyItNow() {
  const variantId = document.getElementById("v-product-variant-id")?.value;
  const qty = parseInt(document.getElementById("v-hidden-qty")?.value || "1", 10);
  if (!variantId) return;

  const btn = document.querySelector(".v-btn-primary[onclick]");
  if (btn) {
    btn.disabled = true;
    btn.textContent = "...";
  }

  fetch("/cart/add.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ items: [{ id: Number(variantId), quantity: qty }] })
  })
    .then(() => {
      window.location.href = "/checkout";
    })
    .catch(() => {
      window.location.href = "/checkout";
    })
    .finally(() => {
      if (btn) {
        btn.disabled = false;
        btn.textContent = "EXPERIENCE NOW";
      }
    });
}

document.addEventListener("DOMContentLoaded", () => {
  // ─── STATE & INIT ───────────────────────────────────────────────────────────
  const variantDataEl = document.getElementById("v-variant-data");
  const variantData = variantDataEl ? JSON.parse(variantDataEl.textContent) : [];
  const hiddenIdInput = document.getElementById("v-product-variant-id");
  const hiddenQtyInput = document.getElementById("v-hidden-qty");
  const qtyDisplay = document.getElementById("v-main-qty");
  const totalPriceDisplay = document.getElementById("v-total-price-display");
  
const headerPriceDisplays = document.querySelectorAll(
  "#v-header-price, #v-mobile-header-price"
);

const addToBagPrice = document.querySelector(".kb-atc-price");


  
const galleryFrame = document.querySelector("[data-gallery-frame]");

const thumbs = Array.from(
  document.querySelectorAll("[data-gallery-thumb]")
);

const gallerySlides = Array.from(
  document.querySelectorAll("[data-gallery-slide]")
);

const galleryCounter = document.querySelector(
  "[data-gallery-current]"
);

  const testimonialCarousel = document.querySelector("[data-testimonial-carousel]");
  let testimonialDots = Array.from(document.querySelectorAll("[data-testimonial-dot]"));

  const state = {
    option1: null,
    option2: null,
    option3: null,
    qty: 1,
    basePrice: variantData[0]?.price ?? 0,
    activeImageIndex: Math.max(
      thumbs.findIndex((thumb) => thumb.classList.contains("is-active")),
      0
    )
  };

  document.querySelectorAll(".v-selector-item.is-active").forEach((btn) => {
    state[`option${btn.dataset.optionPos}`] = btn.dataset.value;
  });

  const formatter = {
  format(amount) {
    return "R " + Number(amount).toFixed(2);
  }
};
// ─── BUCKS CURRENCY OBSERVER MANAGEMENT ───────────────────────────────

// Keep at most one active conversion observer per price element.
const bucksPriceObservers = new Map();

function disconnectBucksObserver(element) {
  const observer = bucksPriceObservers.get(element);

  if (observer) {
    observer.disconnect();
    bucksPriceObservers.delete(element);
  }
}
// ─── KAROO BABA MEDIA GALLERY ───────────────────────


function setActiveThumb(index) {
  const total = thumbs.length;

  thumbs.forEach((thumb, thumbIndex) => {
    const isActive = thumbIndex === index;

    thumb.classList.toggle("is-active", isActive);
    thumb.setAttribute("aria-pressed", String(isActive));

    if (total <= 1) {
      thumb.hidden = true;
      return;
    }

    const nextOne = (index + 1) % total;
    const nextTwo = (index + 2) % total;

    thumb.hidden =
      thumbIndex !== nextOne &&
      (total <= 2 || thumbIndex !== nextTwo);
  });
}


function updateHeroImage(index) {
  if (!gallerySlides.length || !gallerySlides[index]) return;

  // Stop videos when switching media.
  gallerySlides.forEach((slide) => {
    slide.querySelectorAll("video").forEach((video) => {
      video.pause();
    });
  });

  gallerySlides.forEach((slide, slideIndex) => {
    const isActive = slideIndex === index;

    slide.hidden = !isActive;
    slide.classList.toggle("is-active", isActive);
  });

  state.activeImageIndex = index;
  // Restart a Shopify-hosted video when its slide becomes active.
const activeSlide = gallerySlides[index];
const activeVideo = activeSlide?.querySelector("video");

if (activeVideo) {
  activeVideo.play().catch(() => {
    // Playback may be restricted by the browser.
  });
}

  setActiveThumb(index);

  if (galleryCounter) {
    galleryCounter.textContent = index + 1;
  }
}
// Display the Shopify image assigned to the selected variant.
function showVariantMedia(variant) {
  if (!variant || !variant.featured_media_id) return;

  const mediaId = String(variant.featured_media_id);

  const mediaIndex = gallerySlides.findIndex(
    (slide) => slide.dataset.mediaId === mediaId
  );

  if (mediaIndex !== -1 && mediaIndex !== state.activeImageIndex) {
    updateHeroImage(mediaIndex);
  }
}
function stepGallery(direction) {
  if (!gallerySlides.length) return;

  const nextIndex =
    (state.activeImageIndex + direction + gallerySlides.length)
    % gallerySlides.length;

  updateHeroImage(nextIndex);
}

  // ─── TESTIMONIALS ────────────────────────────────────────────────────────────
  function stepTestimonials(direction) {
    if (!testimonialCarousel) return;

    const firstCard = testimonialCarousel.querySelector(".v-testimonial-card");
    const gap = 20;
    const cardWidth = firstCard ? firstCard.getBoundingClientRect().width + gap : 340;

    testimonialCarousel.scrollBy({
      left: cardWidth * cardsPerPage() * direction,
      behavior: "smooth"
    });
  }

  function setActiveTestimonialDot(index) {
    testimonialDots.forEach((dot, dotIndex) => {
      const isActive = dotIndex === index;
      dot.classList.toggle("is-active", isActive);
      dot.setAttribute("aria-pressed", String(isActive));
    });
  }

  function cardsPerPage() {
    return window.innerWidth <= 768 ? 1 : 2;
  }

  function updateTestimonialDots() {
    if (!testimonialCarousel || !testimonialDots.length) return;

    const firstCard = testimonialCarousel.querySelector(".v-testimonial-card");
    const gap = 20;
    const cardWidth = firstCard ? firstCard.getBoundingClientRect().width + gap : 340;
    const cpp = cardsPerPage();
    // On desktop (cpp=2) snap groups are pairs, so round to nearest even index.
    // On mobile (cpp=1) every card has its own dot.
    const page = Math.round(testimonialCarousel.scrollLeft / (cardWidth * cpp));
    const dotIndex = page * (cpp === 2 ? 2 : 1);

    setActiveTestimonialDot(Math.max(0, Math.min(dotIndex, testimonialDots.length - 1)));
  }

  function goToTestimonial(index) {
    if (!testimonialCarousel) return;

    const firstCard = testimonialCarousel.querySelector(".v-testimonial-card");
    const gap = 20;
    const cardWidth = firstCard ? firstCard.getBoundingClientRect().width + gap : 340;

    // data-index maps 1:1 to card position regardless of breakpoint
    testimonialCarousel.scrollTo({
      left: cardWidth * index,
      behavior: "smooth"
    });
  }

  // ─── VARIANT & DISPLAY UPDATE ────────────────────────────────────────────────

  // Update PRE-ORDER labels for each size option.
function updateSizePreorderLabels() {
  document.querySelectorAll(".v-option-group").forEach((group) => {
    const heading = group.querySelector(".v-option-info h3");

    if (!heading || heading.textContent.trim().toLowerCase() !== "size") {
      return;
    }

    group.querySelectorAll(".v-selector-item").forEach((button) => {
      const preorderLabel = button.querySelector(".v-selector-preorder");
      const optionKey = `option${button.dataset.optionPos}`;

      const matchingVariants = variantData.filter((variant) => {
        if (variant[optionKey] !== button.dataset.value) {
          return false;
        }

        return [1, 2, 3].every((position) => {
          const key = `option${position}`;

          if (key === optionKey || !state[key]) {
            return true;
          }

          return variant[key] === state[key];
        });
      });

      const hasAvailableVariant = matchingVariants.some(
        (variant) => variant.available === true
      );

      const isSoldOut = !hasAvailableVariant;

      const isPreorder =
        hasAvailableVariant &&
        matchingVariants.every(
          (variant) =>
            variant.inventory_management === "shopify" &&
            variant.inventory_quantity <= 0 &&
            variant.inventory_policy === "continue"
        );

      button.disabled = isSoldOut;
      button.classList.toggle("is-sold-out", isSoldOut);
      button.setAttribute("aria-disabled", String(isSoldOut));

      if (preorderLabel) {
        preorderLabel.hidden = !isPreorder;
      }
    });
  });
}
// Find the variant matching the selected options.
function getSelectedVariant() {
  return variantData.find(
    (variant) =>
      (!state.option1 || variant.option1 === state.option1) &&
      (!state.option2 || variant.option2 === state.option2) &&
      (!state.option3 || variant.option3 === state.option3)
  );
}

// Calculate how the selected quantity relates to inventory.
function getQuantityAvailability(variant, quantity) {
  if (!variant) {
    return {
      soldOut: true,
      madeToOrder: false,
      limit: 0,
      stockUnits: 0,
      madeToOrderUnits: 0
    };
  }

  const tracked = variant.inventory_management === "shopify";
  const continueSelling = variant.inventory_policy === "continue";
  const stock = Math.max(0, Number(variant.inventory_quantity) || 0);

  const limit = tracked && !continueSelling ? stock : Infinity;
  const soldOut = variant.available === false || limit === 0;

  const stockUnits = tracked ? Math.min(quantity, stock) : quantity;
  const madeToOrderUnits =
    tracked && continueSelling ? Math.max(0, quantity - stock) : 0;

  return {
    soldOut,
    madeToOrder: madeToOrderUnits > 0,
    limit,
    stockUnits,
    madeToOrderUnits
  };
}
// ─── PAYFLEX — KEEP WIDGET IN SYNC WITH SELECTED VARIANT ───

let payflexSyncTimer = null;

function updatePayflexPrice(variant) {
  if (!variant) return;

  // Shopify prices are stored in cents.
  const amount = Number(variant.price) / 100;

  if (!Number.isFinite(amount) || amount <= 0) return;

  // Cancel any previous pending synchronisation.
  if (payflexSyncTimer !== null) {
    clearInterval(payflexSyncTimer);
    payflexSyncTimer = null;
  }

  let attempts = 0;
  const maxAttempts = 40;

  function syncPayflex() {
    attempts++;

    if (
      window.PayflexWidget &&
      typeof window.PayflexWidget.update === "function"
    ) {
      window.PayflexWidget.update(amount);

      clearInterval(payflexSyncTimer);
      payflexSyncTimer = null;
      return;
    }

    // Stop checking after 10 seconds.
    if (attempts >= maxAttempts) {
      clearInterval(payflexSyncTimer);
      payflexSyncTimer = null;
    }
  }

  // Update immediately if Payflex is already available.
  syncPayflex();

  // Otherwise, wait briefly for the asynchronous script to load.
  if (
    !window.PayflexWidget ||
    typeof window.PayflexWidget.update !== "function"
  ) {
    payflexSyncTimer = setInterval(syncPayflex, 250);
  }
}
function updateDisplay() {
  const match = getSelectedVariant();

    if (match) {
      state.basePrice = match.price;
      if (hiddenIdInput) hiddenIdInput.value = match.id;
      updatePayflexPrice(match);
      // Keep the selected Shopify variant in the URL.
const variantUrl = new URL(window.location.href);

if (variantUrl.searchParams.get("variant") !== String(match.id)) {
  variantUrl.searchParams.set("variant", String(match.id));

  window.history.replaceState(
    window.history.state,
    "",
    variantUrl.toString()
  );
}

const availability = getQuantityAvailability(match, state.qty);

// Reset quantity for a completely unavailable variant.
if (availability.soldOut) {
  state.qty = 1;
}

// Respect Shopify's inventory limit when overselling is disabled.
else if (
  Number.isFinite(availability.limit) &&
  state.qty > availability.limit
) {
  state.qty = Math.max(1, availability.limit);
}
const currentAvailability = getQuantityAvailability(match, state.qty);

const isSoldOut = currentAvailability.soldOut;
const isPreorder = currentAvailability.madeToOrder;

const atcBtn = document.getElementById("v-atc-btn");

if (atcBtn) {
  atcBtn.dataset.preorder = String(isPreorder);
  atcBtn.disabled = isSoldOut;

  const atcLabel = atcBtn.querySelector(".kb-atc-label");

  if (atcLabel) {
    atcLabel.textContent = isSoldOut
      ? "SOLD OUT"
      : isPreorder
        ? "MADE TO ORDER"
        : "ADD TO BAG";
  }
}

const mobileAtc = document.querySelector(".v-mobile-atc");

if (mobileAtc) {
  mobileAtc.disabled = isSoldOut;
  mobileAtc.textContent = isSoldOut
    ? "SOLD OUT"
    : isPreorder
      ? "MADE TO ORDER"
      : "ADD TO BAG";
}

// Show the existing shipping disclaimer when any units
// in the selected quantity need to be made to order.
const stockDisclaimer = document.querySelector(
  "[data-stock-status] > div"
);

if (stockDisclaimer) {
  stockDisclaimer.hidden = !isPreorder;
}

// Display the stock breakdown.
const quantityNotice = document.querySelector(
  "[data-quantity-stock-notice]"
);

const quantityMessage = document.querySelector(
  "[data-quantity-stock-message]"
);

if (quantityNotice && quantityMessage) {
  quantityNotice.hidden = !isPreorder;

  if (isPreorder) {
    const inStock = currentAvailability.stockUnits;
    const madeToOrder = currentAvailability.madeToOrderUnits;

    quantityMessage.textContent =
      inStock > 0
        ? `${inStock} ${inStock === 1 ? "unit" : "units"} in stock · ` +
          `${madeToOrder} ${madeToOrder === 1 ? "unit" : "units"} made to order.`
        : `${madeToOrder} ${madeToOrder === 1 ? "unit" : "units"} made to order.`;
  } else {
    quantityMessage.textContent = "";
  }
}

// Keep the displayed quantity synchronised.
if (qtyDisplay) {
  qtyDisplay.value = state.qty;
}
    }


const formattedTotal = formatter.format(
  (state.basePrice * state.qty) / 100
);

const formattedHeader = formatter.format(state.basePrice / 100);

// Read the currency currently selected by Bucks.
const selectedCurrency = (
  document.querySelector("[bucks-currency]")
    ?.getAttribute("bucks-currency") || "ZAR"
).toUpperCase();

const isZAR = selectedCurrency === "ZAR";

// Update a price without creating duplicate conversion observers.
function updatePrice(priceEl, newPrice) {
  if (!priceEl) return;

  const currentCurrency = priceEl.getAttribute("bucks-currency");
  const originalPrice = priceEl.getAttribute("bucks-original")?.trim();
  const currentText = priceEl.textContent.trim();

  // Avoid rewriting a price that already represents
  // the correct ZAR amount or its converted equivalent.
  const alreadyCorrect = isZAR
    ? currentText === newPrice
    : currentCurrency === selectedCurrency &&
      originalPrice === newPrice &&
      currentText !== newPrice;

  if (alreadyCorrect) {
    disconnectBucksObserver(priceEl);
    priceEl.style.visibility = "visible";
    return;
  }

  // Remove the observer from the previous price update.
  disconnectBucksObserver(priceEl);

  if (isZAR) {
    priceEl.textContent = newPrice;
    priceEl.style.visibility = "visible";
    return;
  }

  // Hide the original ZAR value while Bucks converts it.
  priceEl.style.visibility = "hidden";

  // Bucks observes price changes and performs the conversion.
  priceEl.textContent = newPrice;

  const observer = new MutationObserver(() => {
    const convertedCurrency =
      priceEl.getAttribute("bucks-currency");

    const convertedPrice =
      priceEl.getAttribute("bucks-current");

    const convertedOriginal =
      priceEl.getAttribute("bucks-original")?.trim();

    if (
      convertedCurrency === selectedCurrency &&
      convertedPrice &&
      convertedOriginal === newPrice &&
      priceEl.textContent.trim() === convertedPrice
    ) {
      priceEl.style.visibility = "visible";
      disconnectBucksObserver(priceEl);
    }
  });

  bucksPriceObservers.set(priceEl, observer);

  observer.observe(priceEl, {
    attributes: true,
    childList: true,
    characterData: true,
    subtree: true
  });
}

// Main product heading and mobile heading: unit price.
headerPriceDisplays.forEach((priceEl) => {
  updatePrice(priceEl, formattedHeader);
});

// Add to Bag button and total price: quantity-adjusted price.
updatePrice(addToBagPrice, formattedTotal);
updatePrice(totalPriceDisplay, formattedTotal);

if (hiddenQtyInput) hiddenQtyInput.value = state.qty;
    updateSizePreorderLabels();
  }

  // ─── OOS MODAL FORM INTERCEPTION ─────────────────────────────────────────────
  const manualForm = document.getElementById("v-manual-form");
  if (manualForm) {
    manualForm.addEventListener("submit", (e) => {
      const atcBtn = document.getElementById("v-atc-btn");
      if (atcBtn?.dataset.preorder === "true") {
        e.preventDefault();
        openOosModal(() => manualForm.submit());
      }
    });
  }

  // ─── EVENT DELEGATION ────────────────────────────────────────────────────────
  document.addEventListener("click", (event) => {
    if (event.target.closest("[data-oos-confirm]")) {
      const cb = _oosConfirmCallback;
      closeOosModal();
      if (cb) cb();
      return;
    }

    if (event.target.closest("[data-oos-cancel]") || event.target === document.getElementById("v-oos-modal")) {
      closeOosModal();
      return;
    }
    // Mobile purchase button uses the same form and
// made-to-order confirmation as the desktop button.
const mobilePurchaseBtn = event.target.closest(".v-mobile-atc");

if (mobilePurchaseBtn) {
  if (mobilePurchaseBtn.disabled) return;

  const mainPurchaseBtn = document.getElementById("v-atc-btn");

  if (mainPurchaseBtn && !mainPurchaseBtn.disabled) {
    mainPurchaseBtn.click();
  }

  return;
}
    const accordionTrigger = event.target.closest("[data-accordion-trigger]");
    if (accordionTrigger) {
      const accordionItem = accordionTrigger.closest(".v-accordion-item");
      const accordionPanel = accordionItem?.querySelector("[data-accordion-panel]");
      const shouldOpen = accordionTrigger.getAttribute("aria-expanded") !== "true";

      document.querySelectorAll(".v-accordion-item").forEach((item) => {
        item.classList.remove("is-open");
        item.querySelector("[data-accordion-trigger]")?.setAttribute("aria-expanded", "false");
        item.querySelector("[data-accordion-panel]")?.setAttribute("hidden", "");
      });

      if (shouldOpen && accordionItem && accordionPanel) {
        accordionItem.classList.add("is-open");
        accordionTrigger.setAttribute("aria-expanded", "true");
        accordionPanel.removeAttribute("hidden");
      }

      return;
    }

    const selectorBtn = event.target.closest(".v-selector-item");
    if (selectorBtn) {
      if (selectorBtn.disabled) return;
      state[`option${selectorBtn.dataset.optionPos}`] = selectorBtn.dataset.value;
      
selectorBtn
  .closest(".v-variant-selector-grid")
  ?.querySelectorAll(".v-selector-item")
  .forEach((item) => {
    item.classList.remove("is-active");
    item.setAttribute("aria-pressed", "false");
  });

selectorBtn.classList.add("is-active");
selectorBtn.setAttribute("aria-pressed", "true");

const summaryField = document.querySelector(
  `[data-summary-ref="${selectorBtn.dataset.optionPos}"]`
);

if (summaryField) {
  summaryField.textContent = selectorBtn.dataset.value;
}

updateDisplay();

showVariantMedia(getSelectedVariant());

return;
}

const qtyBtn = event.target.closest(".v-qty-btn");

if (qtyBtn) {
  const variant = getSelectedVariant();
  const availability = getQuantityAvailability(variant, state.qty);

  if (qtyBtn.dataset.action === "plus") {
    if (state.qty < availability.limit && !availability.soldOut) {
      state.qty += 1;
    }
  }

  if (qtyBtn.dataset.action === "minus" && state.qty > 1) {
    state.qty -= 1;
  }

  updateDisplay();
  return;
}
    const thumbBtn = event.target.closest("[data-gallery-thumb]");
    if (thumbBtn) {
      updateHeroImage(thumbs.indexOf(thumbBtn));
      return;
    }

    const navBtn = event.target.closest("[data-gallery-nav]");
    if (navBtn) {
      stepGallery(navBtn.dataset.galleryNav === "next" ? 1 : -1);
      return;
    }

    const testimonialNavBtn = event.target.closest("[data-testimonial-nav]");
    if (testimonialNavBtn) {
      stepTestimonials(testimonialNavBtn.dataset.testimonialNav === "next" ? 1 : -1);
      return;
    }

    const testimonialDotBtn = event.target.closest("[data-testimonial-dot]");
    if (testimonialDotBtn) {
      goToTestimonial(Number(testimonialDotBtn.dataset.index));
      return;
    }

    const openModalBtn = event.target.closest("[data-open-testimonial-modal]");
    if (openModalBtn) {
      openTestimonialModal();
      return;
    }

    const closeModalBtn = event.target.closest("[data-close-testimonial-modal]");
    if (closeModalBtn) {
      closeTestimonialModal();
      return;
    }

    // Click on backdrop outside the modal card closes it
    if (event.target === modalEl) {
      closeTestimonialModal();
    }
  });
// ─── KEYBOARD NAVIGATION ───────────────────────────────────────────────
document.addEventListener("keydown", (event) => {
  const activeOosModal = document.getElementById("v-oos-modal");

  // Keep keyboard focus inside the made-to-order modal.
  if (activeOosModal && !activeOosModal.hidden) {
    if (event.key === "Tab") {
      const focusable = Array.from(
        activeOosModal.querySelectorAll(
          'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
        )
      ).filter((element) => element.getClientRects().length > 0);

      if (focusable.length) {
        const first = focusable[0];
        const last = focusable[focusable.length - 1];

        if (!activeOosModal.contains(document.activeElement)) {
          event.preventDefault();
          first.focus();
        } else if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }
    }

    if (event.key === "Escape") {
      event.preventDefault();
      closeOosModal();
    }

    // Do not allow gallery keyboard navigation behind the modal.
    return;
  }

  // Close testimonial modal with Escape.
  if (event.key === "Escape" && modalEl && !modalEl.hidden) {
    closeTestimonialModal();
    return;
  }

  // Gallery arrow-key navigation.
  if (!galleryFrame || !galleryFrame.matches(":hover")) return;

  if (event.key === "ArrowRight") stepGallery(1);
  if (event.key === "ArrowLeft") stepGallery(-1);
});
  // ─── TESTIMONIAL MODAL ────────────────────────────────────────────────────────
  const modalEl = document.querySelector("[data-testimonial-modal]");

  function openTestimonialModal() {
    if (!modalEl) return;
    modalEl.hidden = false;
    modalEl.removeAttribute("aria-hidden");
    document.body.style.overflow = "hidden";
    modalEl.querySelector("[data-close-testimonial-modal]")?.focus();
  }

  function closeTestimonialModal() {
    if (!modalEl) return;
    modalEl.hidden = true;
    modalEl.setAttribute("aria-hidden", "true");
    document.body.style.overflow = "";
    resetTestimonialForm();
  }

  function resetTestimonialForm() {
    const form = modalEl?.querySelector("[data-testimonial-form]");
    if (!form) return;
    form.reset();
    form.querySelectorAll("[data-error-for]").forEach((el) => {
      el.hidden = true;
    });
    const fileLabel = form.querySelector("[data-file-label]");
    if (fileLabel) fileLabel.textContent = "Choose image or drag here";
    const status = form.querySelector("[data-form-status]");
    if (status) {
      status.hidden = true;
      status.className = "v-form-status";
      status.textContent = "";
    }
    setSubmitting(form, false);
  }

  function setSubmitting(form, busy) {
    const btn = form.querySelector("[data-submit-btn]");
    const labelEl = form.querySelector("[data-submit-label]");
    const loadingEl = form.querySelector("[data-submit-loading]");
    if (!btn) return;
    btn.disabled = busy;
    if (labelEl) labelEl.hidden = busy;
    if (loadingEl) loadingEl.hidden = !busy;
  }

  function showFieldError(form, fieldName, message) {
    const errEl = form.querySelector(`[data-error-for="${fieldName}"]`);
    if (!errEl) return;
    errEl.textContent = message;
    errEl.hidden = false;
  }

  function clearFieldError(form, fieldName) {
    const errEl = form.querySelector(`[data-error-for="${fieldName}"]`);
    if (errEl) errEl.hidden = true;
  }

  async function uploadImage(file) {
    const cfg = window.vShopConfig;
    if (!cfg?.uploadEndpoint) throw new Error("Upload endpoint not configured.");

    // Step 1 — get signed S3 URL from proxy (calls Shopify Admin API server-side)
    const stageRes = await fetch(cfg.uploadEndpoint, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        action: "stage",
        filename: file.name,
        mimeType: file.type
      })
    });
    if (!stageRes.ok) throw new Error("Could not prepare image upload.");
    const { uploadUrl, resourceUrl, parameters } = await stageRes.json();

    // Step 2 — upload file directly to S3 (no credentials needed, signed URL is safe)
    const s3Form = new FormData();
    parameters.forEach(({ name, value }) => s3Form.append(name, value));
    s3Form.append("file", file);
    const s3Res = await fetch(uploadUrl, { method: "POST", body: s3Form });
    if (!s3Res.ok) throw new Error("Image upload failed.");

    // Step 3 — register file with Shopify CDN and get final URL
    const finalRes = await fetch(cfg.uploadEndpoint, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ action: "finalize", resourceUrl })
    });
    if (!finalRes.ok) throw new Error("Could not finalise image on CDN.");
    const { cdnUrl } = await finalRes.json();
    return cdnUrl;
  }

 function buildTestimonialCard({ quote, display_name, image_url }) {
  const card = document.createElement("div");
  card.className = "v-testimonial-card";

  // Only display images from the expected Shopify CDN.
  if (image_url) {
    try {
      const url = new URL(image_url, window.location.origin);

      if (
        url.protocol === "https:" &&
        (
          url.hostname === "cdn.shopify.com" ||
          url.hostname === "shopify.com" ||
          url.hostname.endsWith(".cdn.shopify.com")
        )
      ) {
        const img = document.createElement("img");
        img.src = url.href;
        img.alt = "";
        img.className = "v-testimonial-img";
        img.loading = "lazy";
        card.appendChild(img);
      }
    } catch (error) {
      console.warn("Invalid testimonial image URL.");
    }
  }

  // Customer text must never be interpreted as HTML.
  const paragraph = document.createElement("p");
  paragraph.textContent = `"${quote}"`;
  card.appendChild(paragraph);

  if (display_name) {
    const cite = document.createElement("cite");
    cite.textContent = `— ${display_name}`;
    card.appendChild(cite);
  }

  return card;
}

  function buildTestimonialDot(index, isActive) {
    return `<button
      type="button"
      class="v-testimonial-dot${isActive ? " is-active" : ""}"
      data-testimonial-dot
      data-index="${index}"
      aria-label="Go to testimonial ${index + 1}"
      aria-pressed="${isActive}"
    ></button>`;
  }

  async function submitTestimonial(form) {
    const cfg = window.vShopConfig || {};

    const data = new FormData(form);
    const quote = (data.get("quote") || "").trim();
    const email = (data.get("email") || "").trim();
    const displayName = (data.get("display_name") || "").trim();
    const imageFile = data.get("image");

    // Validate
    let valid = true;
    if (!quote) {
      showFieldError(form, "quote", "Please share your experience before submitting.");
      valid = false;
    } else clearFieldError(form, "quote");

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!email || !emailRegex.test(email)) {
      showFieldError(form, "email", "A valid email address is required.");
      valid = false;
    } else clearFieldError(form, "email");

    if (imageFile && imageFile.size > 5 * 1024 * 1024) {
      showFieldError(form, "image", "Image must be under 5 MB.");
      valid = false;
    } else clearFieldError(form, "image");

    if (!valid) return false;

    setSubmitting(form, true);

    // Upload image best-effort — a failed upload never blocks the submission
    let imageUrl = "";
    if (imageFile && imageFile.size > 0 && cfg.uploadEndpoint) {
      try {
        imageUrl = await uploadImage(imageFile);
      } catch (uploadErr) {
        console.warn("Testimonial image upload failed, continuing without image:", uploadErr);
      }
    }

    // Try to create metaobject via server-side proxy (best-effort).
    // If the proxy is unavailable the notification email still goes through below.
    let metaobjectGid = "";
    if (cfg.uploadEndpoint) {
      const fields = [
        { key: "product_handle", value: cfg.productHandle || "" },
        { key: "content", value: quote },
        { key: "submitted_at", value: new Date().toISOString() },
        { key: "email", value: email }
      ];
      if (displayName) fields.push({ key: "display_name", value: displayName });
      if (imageUrl) fields.push({ key: "image_url", value: imageUrl });

      try {
        const res = await fetch(cfg.uploadEndpoint, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ action: "submit", fields })
        });
        if (res.ok) {
          const json = await res.json();
          const { userErrors = [], errors = [] } = json;
          if (!errors.length && !userErrors.length) {
            metaobjectGid = json.data?.metaobjectCreate?.metaobject?.id || json.metaobjectId || json.id || "";
          }
        }
      } catch (proxyErr) {
        console.warn("Metaobject creation via proxy failed, notification email will still be sent:", proxyErr);
      }
    }

    // Optimistically append the new card to the carousel
    const newTestimonial = {
      quote,
      display_name: displayName,
      image_url: imageUrl
    };
    if (testimonialCarousel && !testimonialCarousel.hidden) {
     testimonialCarousel.prepend(buildTestimonialCard(newTestimonial));
      testimonialCarousel.scrollTo({ left: 0, behavior: "smooth" });
      const dotsContainer = document.querySelector("[data-testimonial-dots]");
      if (dotsContainer) {
        dotsContainer.querySelectorAll("[data-testimonial-dot]").forEach((dot) => {
          const shifted = Number(dot.dataset.index) + 1;
          dot.dataset.index = shifted;
          dot.setAttribute("aria-label", `Go to testimonial ${shifted + 1}`);
          dot.classList.remove("is-active");
          dot.setAttribute("aria-pressed", "false");
        });
        dotsContainer.insertAdjacentHTML("afterbegin", buildTestimonialDot(0, true));
        testimonialDots = Array.from(dotsContainer.querySelectorAll("[data-testimonial-dot]"));
      }
    } else {
      // First testimonial — swap empty state for a new carousel
      const emptyEl = document.querySelector("[data-testimonial-empty]");
      if (emptyEl) {
        const carousel = document.createElement("div");
        carousel.className = "v-testimonial-carousel";
        carousel.setAttribute("data-testimonial-carousel", "");
        carousel.appendChild(buildTestimonialCard(newTestimonial));
        emptyEl.replaceWith(carousel);

        const dotsContainer = document.querySelector("[data-testimonial-dots]");
        if (dotsContainer) {
          dotsContainer.innerHTML = buildTestimonialDot(0, true);
          testimonialDots = Array.from(dotsContainer.querySelectorAll("[data-testimonial-dot]"));
          carousel.addEventListener("scroll", () => {
            window.requestAnimationFrame(updateTestimonialDots);
          });
        }

        revealObserver.observe(carousel);
      }
    }

    // Send shop notification email via Shopify contact form
    const notifyForm = document.getElementById("v-testimonial-notify-form");
    if (notifyForm) {
      const tnBody = document.getElementById("v-tn-body");
      const tnEmail = document.getElementById("v-tn-email");
      const tnName = document.getElementById("v-tn-name");

      let adminUrl = cfg.shopDomain ? "https://" + cfg.shopDomain + "/admin/content/entries/product_testimonial" : "";
      if (adminUrl && metaobjectGid) adminUrl += "/" + metaobjectGid.split("/").pop();

      let body = "--- NEW TESTIMONIAL SUBMITTED ---\n\n";
      body += "Product: " + (cfg.productHandle || "N/A") + "\n";
      body += "Quote: " + quote + "\n";
      body += "Display Name: " + (displayName || "(not provided)") + "\n";
      body += "Email: " + email + "\n";
      body += "Photo: " + (imageUrl || "(none)") + "\n\n";
      if (adminUrl) body += "--- REPLY LINK ---\n" + adminUrl + "\n";

      if (tnBody) tnBody.value = body;
      if (tnEmail) tnEmail.value = email;
      if (tnName) tnName.value = "New Testimonial — " + (cfg.productHandle || "product");

      // Trigger Shopify's built-in captcha interceptor by firing a submit event.
      // The interceptor (injected via content_for_header) calls e.preventDefault(),
      // executes hCaptcha invisibly, injects h-captcha-response, then calls
      // form.submit(). The form has target="v-notify-frame" so form.submit() posts
      // into the hidden iframe — no page navigation. The server receives the POST,
      // validates the captcha, and sends the notification email. The response is
      // discarded by the browser (frame-ancestors: none CSP) — expected and harmless.
      notifyForm.requestSubmit();
    }

    return true;
  }

  // ─── REVEAL ANIMATIONS ───────────────────────────────────────────────────────
  const revealTargets = document.querySelectorAll(".v-reveal, .v-testimonial-section, .v-curated-section");

  const revealObserver = new IntersectionObserver(
    (entries, observer) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add("v-reveal", "is-visible");
        observer.unobserve(entry.target);
      });
    },
    {
      threshold: 0.12,
      rootMargin: "0px 0px -8% 0px"
    }
  );

  revealTargets.forEach((target) => revealObserver.observe(target));

  if (testimonialCarousel && testimonialDots.length) {
    testimonialCarousel.addEventListener("scroll", () => {
      window.requestAnimationFrame(updateTestimonialDots);
    });

    updateTestimonialDots();
    revealObserver.observe(testimonialCarousel);
  }


// ─── MOBILE CTA VISIBILITY ───────────────────────────────────────────────────

const floatingEl = document.querySelector(".v-mobile-cta");
const mainPurchaseButton = document.getElementById("v-atc-btn");

if (floatingEl && mainPurchaseButton) {
  const mobileQuery = window.matchMedia("(max-width: 768px)");

  const purchaseObserver = new IntersectionObserver(
    (entries) => {
      const mainButtonVisible = entries[0].isIntersecting;

      // CSS controls desktop/mobile display.
      // Hide the sticky bar when the main purchase button is visible.
      floatingEl.style.opacity = mainButtonVisible ? "0" : "1";
      floatingEl.style.visibility = mainButtonVisible ? "hidden" : "visible";
      floatingEl.style.pointerEvents = mainButtonVisible ? "none" : "auto";
    },
    {
      threshold: 0.1
    }
  );

  purchaseObserver.observe(mainPurchaseButton);

  // Prevent the sticky bar from appearing on desktop.
  const syncMobileVisibility = () => {
    if (!mobileQuery.matches) {
      floatingEl.style.opacity = "";
      floatingEl.style.visibility = "";
      floatingEl.style.pointerEvents = "";
    }
  };

  mobileQuery.addEventListener("change", syncMobileVisibility);
  syncMobileVisibility();
}
  // ─── SETUP ───────────────────────────────────────────────────────────────────
  updateHeroImage(state.activeImageIndex);
updateDisplay();

  // Wire testimonial form submit
  const testimonialForm = document.querySelector("[data-testimonial-form]");
  if (testimonialForm) {
    testimonialForm.addEventListener("submit", async (e) => {
      e.preventDefault();
      const status = testimonialForm.querySelector("[data-form-status]");
      try {
        const success = await submitTestimonial(testimonialForm);
        if (success) {
          if (status) {
            status.textContent = "Thank you — your testimonial has been submitted.";
            status.className = "v-form-status is-success";
            status.hidden = false;
          }
          window.setTimeout(closeTestimonialModal, 2400);
        }
      } catch (err) {
        setSubmitting(testimonialForm, false);
        if (status) {
          status.textContent = err.message || "Something went wrong. Please try again.";
          status.className = "v-form-status is-error";
          status.hidden = false;
        }
      }
    });
  }

  // Wire file input label update
  const fileInput = document.querySelector('[name="image"]');
  const fileLabel = document.querySelector("[data-file-label]");
  if (fileInput && fileLabel) {
    fileInput.addEventListener("change", () => {
      const file = fileInput.files?.[0];
      fileLabel.textContent = file ? file.name : "Choose image or drag here";
    });
  }
});
/* =========================================
   KAROO BABA — PRODUCT INFORMATION TABS
   ========================================= */

document.addEventListener("DOMContentLoaded", () => {
  const tabContainer = document.querySelector(".kb-info-tabs");

  if (!tabContainer) return;

  const tabs = Array.from(
    tabContainer.querySelectorAll("[data-kb-tab]")
  );

  const panels = Array.from(
    document.querySelectorAll("[data-kb-panel]")
  );

  function activateTab(tab, moveFocus = false) {
    const target = tab.dataset.kbTab;

    tabs.forEach((item) => {
      const active = item === tab;

      item.classList.toggle("is-active", active);
      item.setAttribute("aria-selected", String(active));
      item.tabIndex = active ? 0 : -1;
    });

    panels.forEach((panel) => {
      const active = panel.dataset.kbPanel === target;

      panel.classList.toggle("is-active", active);
    });

    if (moveFocus) tab.focus();
  }

  tabs.forEach((tab, index) => {
    tab.addEventListener("click", () => {
      activateTab(tab);
    });

    tab.addEventListener("keydown", (event) => {
      let nextIndex;

      if (event.key === "ArrowRight") {
        nextIndex = (index + 1) % tabs.length;
      } else if (event.key === "ArrowLeft") {
        nextIndex = (index - 1 + tabs.length) % tabs.length;
      } else if (event.key === "Home") {
        nextIndex = 0;
      } else if (event.key === "End") {
        nextIndex = tabs.length - 1;
      } else {
        return;
      }

      event.preventDefault();
      activateTab(tabs[nextIndex], true);
    });
  });

  activateTab(tabs[0]);
});
/* =========================================
   KAROO BABA — MOBILE INFORMATION ACCORDIONS
   ========================================= */

document.addEventListener("DOMContentLoaded", () => {
  const triggers = Array.from(
    document.querySelectorAll("[data-kb-mobile-trigger]")
  );

  if (!triggers.length) return;

  function setMobilePanel(name) {
    triggers.forEach((trigger) => {
      const isOpen = trigger.dataset.kbMobileTrigger === name;

      trigger.setAttribute("aria-expanded", String(isOpen));
    });

    document.querySelectorAll("[data-kb-panel]").forEach((panel) => {
      panel.classList.toggle(
        "is-mobile-open",
        panel.dataset.kbPanel === name
      );
    });
  }

  triggers.forEach((trigger) => {
    trigger.addEventListener("click", () => {
      const name = trigger.dataset.kbMobileTrigger;
      const isOpen = trigger.getAttribute("aria-expanded") === "true";

      setMobilePanel(isOpen ? null : name);
    });
  });

  setMobilePanel("description");
});